export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q02_a.10d34369.png";